import {
  GET_HIC,
  GET_HIC_SUCCESS,
  GET_HIC_FAILURE,
} from '../actions/hic';

const INITIAL_STATE = { loading: true, requested: false };

export default function (state = INITIAL_STATE, action) {
  switch (action.type) {
    case GET_HIC:
      return {
        ...state,
        loading: true,
        error: false,
        requested: true,
      };
    case GET_HIC_SUCCESS:
      return {
        ...state,
        loading: false,
        error: false,
        data: action.payload,
      };
    case GET_HIC_FAILURE:
      return {
        ...state,
        loading: false,
        error: action.payload,
      };
    default:
      return state;
  }
}
